// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__UU3wg","toggle":"styles_toggle__33j5B","preview":"styles_preview__3OzAG"};